import React from 'react'
import css from './section.module.css'
const Box = ({box}) => {
  const {color, bgColor, number, desc} = box ;

  return (
    <div style={{backgroundColor: bgColor, color: color}} className={css.single_box}>
      <h2>{number}</h2>
      <h5>{desc}</h5>
    </div>
  )
}

export default Box